import React, { useState, useEffect } from 'react'
import AppHeader from '../components/AppHeader'
import AppSidebar from '../components/AppSidebar'
import Footer from '../components/Footer'
import AddPromoModal from '../components/modals/AddPromoModal'
import Promoarea from '../components/Promoarea'


export default function Promos(props) {
    const {activePage, setActivePage} = props;
    const [notify, setNotify] = useState({
        isOpen: false,
        message: '',
        type: '',
    })

    const [show, setShow] = useState(false);

    useEffect(() => {
        setActivePage('promos');
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    const handleShow = () => {
        setShow(!show);
    }

    const [addPromoLoading, setAddPromoLoading] = useState(false);


    return (
        <div className="app-container app-theme-white body-tabs-shadow fixed-header fixed-sidebar">
            <AppHeader notify={notify} setNotify={setNotify}/>
            <div className="app-main">
            
                <AppSidebar activePage={activePage} setActivePage={setActivePage}/>

                <div className="app-main__outer">
                    <div className="app-main__inner">                        
                    
                        <Promoarea show={show} notify={notify} setNotify={setNotify} handleShow={handleShow} setShow={setShow} addPromoLoading={addPromoLoading} setAddPromoLoading={setAddPromoLoading}/>

                        <Footer/>
                    
                    </div>
                </div>        
            </div>
            <div className="app-drawer-overlay d-none animated fadeIn" />
            <AddPromoModal notify={notify} setNotify={setNotify} show={show}  handleShow={handleShow} setShow={setShow} addPromoLoading={addPromoLoading} setAddPromoLoading={setAddPromoLoading} />
        </div>
        
    )
}
